import React from 'react';
import { Link } from 'react-router-dom';


function Footer(props) {
    return (
        <div>
            <div className="footer">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-4 offset-1 col-sm-2">
                            <h5>链接</h5>
                            <ul className="list-unstyled">
                                <li><Link to='/home'>首页</Link></li>
                                
                                <li><Link to='/menu'>产品服务</Link></li>
                                <li><Link to='/aboutus'>关于我们</Link></li>
                                <li><Link to='/contactus'>联系我们</Link></li>
                            </ul>
                        </div>
                        <div className="col-7 col-sm-5">
                            <h5>联系地址</h5>
                            <address>
                                <i className="fa fa-location-arrow fa-lg"></i>: 江苏省苏州市高新区科发路致远大厦<br />

                                <i className="fa fa-phone fa-lg"></i>: 138 6207 2905<br />

                                <i className="fa fa-envelope fa-lg"></i>: <a href="mailto:jiabantiaoxiu@outlook.com">
                                    jiabantiaoxiu@outlook.com</a>
                            </address>
                        </div>
                        <div className="col-12 col-sm-4 align-self-center">
                            <div className="text-center">




                                {/* <a className="btn btn-social-icon" href="mailto:jiabantiaoxiu@outlook.com"><i className="fa fa-envelope-o"></i></a> */}
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <p>© Copyright 2017-{(new Date()).getFullYear()} 快乐八哥</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer;